import { staticFile } from '@common/utils'
import { AcademicCap } from '@components/common/icons/custom-icons'
import { LazyAPIImage } from '@components/common/image'
import { QUIZZES_IMAGE_PATH } from '@lib/constants/quizzes'
import { CompetititonsListItemType } from '@lib/types/competitions'
import { QuizLinkedEntityType } from '@lib/types/quizzes'
import {
  getFormattedPlayCount,
  getGradeRange,
  onQuizPlay,
} from '@lib/utils/quizzes'
import router from 'next/router'
import { useState } from 'react'

type Props = {
  quiz: CompetititonsListItemType<QuizLinkedEntityType>
}

const QuizCard = ({
  quiz: { title, minGrade, maxGrade, slug, phases },
}: Props) => {
  const {
    id: quizId,
    thumbnail,
    totalProblems,
    playCount,
    quizTopics,
    difficulty,
  } = phases[0].linkedEntity

  const [isLoading, setIsLoading] = useState(false)

  const handleOnPlayButtonClick = async (e) => {
    e.stopPropagation()
    setIsLoading(true)
    const wasParticipationAPICallSuccessful = await onQuizPlay(quizId, slug)
    if (!wasParticipationAPICallSuccessful) setIsLoading(false)
  }

  return (
    <div
      onClick={() => router.push(`/quizzes/${slug}/`)}
      className="flex flex-col bg-white rounded-md border border-white hover:border-orange hover:shadow-md duration-200 cursor-pointer"
    >
      <div className="relative">
        <LazyAPIImage
          src={thumbnail}
          alt={title}
          className="rounded-t-md object-cover w-full h-56"
        />
        <p className="bg-white rounded-t-md mx-6 px-2 absolute bottom-0 left-0">
          Q: {totalProblems}
        </p>
        <p className="bg-white rounded-t-md mx-6 px-2 absolute bottom-0 right-0">
          Plays: {getFormattedPlayCount(playCount)}
        </p>
      </div>
      <div className="flex flex-col items-start p-8 space-y-2">
        <h2 className="text-lg font-600">{title}</h2>
        <div className="flex space-x-1 items-center flex-wrap text-sm">
          {quizTopics.map((topic) => (
            <p
              key={topic}
              className="bg-grey-200 border border-grey-400 rounded-md px-2 my-1"
            >
              {topic}
            </p>
          ))}
        </div>
        <div className="flex items-center space-x-2">
          <AcademicCap className="w-5 stroke-0 text-grey-800" />
          <span>Grade: </span>
          <span className="whitespace-no-wrap">
            {getGradeRange(minGrade, maxGrade)}
          </span>
        </div>
        <div className="flex space-x-2">
          <img
            src={staticFile(
              `${QUIZZES_IMAGE_PATH}${difficulty.toLowerCase()}-level.svg`
            )}
          />
          <span>{difficulty} level</span>
        </div>
        <button
          onClick={handleOnPlayButtonClick}
          className="btn text-orange hover:bg-orange-200 active:bg-orange-300"
          disabled={isLoading}
        >
          Play now
        </button>
      </div>
    </div>
  )
}

export default QuizCard
